import axios from 'axios';
import $ from 'jquery';
import { parseQueryParams } from './shared/utils';
require('./shared/layout');

(function () {
  var pathname = window.location.pathname
  var focusedPricingCardId = null
  if (pathname.startsWith('/multistream/')) {
    focusedPricingCardId = 'multistreaming'
  } else if (pathname.startsWith('/livestreaming-cdn/')) {
    focusedPricingCardId = 'livestream_cdn'
  } else if (pathname.startsWith('/prerecorded-live-scheduler')) {
    focusedPricingCardId = 'pre_recorded_live'
  }

  if (focusedPricingCardId) {
    $('.pricing-card').each(function (i, node) {
      if (node.dataset.product && node.dataset.product !== focusedPricingCardId) {
        $(node).addClass('unfocused')
      } else {
        $(node).addClass('focused')
      }
    })
  }
}());

// header section height set
(function () {
  var setFullHeight = function () {
    $('.header .header-container').css({
      minHeight: window.innerHeight - 60 + 'px',
    });
  };

  // / media query to check
  var landscapeMQ = '(orientation: landscape)';
  // matched or not
  var isLandscape = window.matchMedia(landscapeMQ).matches;
  if (isLandscape) {
    window.addEventListener('load', setFullHeight);
    window.addEventListener('resize', setFullHeight);
  }
})();

// @phone: moving homepage feature preview images to text block 
(function () {
  // / media query to check
  var phoneMQ = '(max-width: 600px) and (orientation: portrait)';
  // matched or not
  var isPhoneView = window.matchMedia(phoneMQ).matches;
  if (isPhoneView) {
    Array.prototype.forEach.call(document.querySelectorAll('.snap_preview_wrap'), function (n) {
      var p = n.parentNode.parentNode
      if (p) {
        var t = p.querySelector('.titles_wrap')
        if (t) {
          t.insertBefore(n, t.querySelector('.desc'))
        }
      }
    })
  }
}());

// testimonial corousal
(function () {
  $('.review_list_actions button').click(function () {
    var el = $(this);
    var reviewList = $('.review_list');
    var maginToMove = parseInt(reviewList.find('.review_item').css('width'));
    var multiplier = parseInt(el.data().direction);

    var oldMargin = parseInt(reviewList.css('marginLeft')) || 0;
    var newMargin = oldMargin + maginToMove * multiplier;

    var maxRotate = reviewList.find('.review_item').length;
    var mostMargin = maginToMove * (maxRotate - 1);
    if (newMargin >= -mostMargin && newMargin <= 0) {
      reviewList.css({ marginLeft: newMargin });
    }
  });
})();

// faq block switcher
(function () {
  var onFaqActivate = function (el) {
    el.classList.add('collapsed');
    el.setAttribute('data-active', '1');
  };

  var faqBlocks = $('.faq_block');
  faqBlocks.click(function () {
    var elthis = this;
    var prevActive = null;
    faqBlocks.each(function (i, el) {
      if (!prevActive && el.hasAttribute('data-active')) {
        prevActive = el;
      }

      if (el !== elthis) {
        el.classList.remove('collapsed');
        el.removeAttribute('data-active');
      }
    });

    if (elthis !== prevActive) {
      onFaqActivate(elthis);
    }
  });
})();

// force enable annual billing on pageload
(function () {
  // $('.pricing-switch-wrap [data-period="y"]').trigger('click')
  $('.pricing-switch-wrap:not([data-prevent-auto-switch]) [data-period="y"]').get(0).click()
})();

// apply any available pricing promos 
(function () {
  var params = parseQueryParams();
  if (params.promo) {
    axios.get('https://eoe61p7ljmm1l05.m.pipedream.net?promo=' + params.promo)
      .then(function (res) {
        var discount = (res.data || {}).discount;
        // console.log('applicable discount', discount);
        if (discount && Number.isFinite(discount.discountedCost)) {
          var discountedCost = 0.8 || discount.discountedCost;
          // var pricingHeads = $('.pricing-rate-hint').next('span');
          var planCategorySelector = ''
          if (discount.planCategory) {
            planCategorySelector = '[data-product="' + discount.planCategory + '"] '
          }

          var pricingHeads = $(planCategorySelector + '.pricing-header-wrap, ' + planCategorySelector + '.plan-id-wrap');
          // console.log('pricingHeads', pricingHeads);
          pricingHeads.each(function (i, node) {
            node = $(node);
            // var costNodes = node.find('.pricing-rate-hint + span');
            var costNodes = node.find('.pricing-rate-period');
            costNodes.each(function (i, costNode) {
              costNode = $(costNode).prev()
              // var costNode = node.find('.pricing-rate-hint').next('span').get(0);
              // console.log('pricingHead', node);
              // var costTxt = costNode.innerText || '';
              var costTxt = costNode.text() || '';
              if (costTxt.startsWith('$')) {
                costTxt = costTxt.slice(1)
                var originalCost = Number(costTxt)
                if (Number.isFinite(originalCost)) {
                  var newCost = originalCost * discountedCost
                  // if (newCost.toString() !== parseInt(newCost).toString()) {
                  //   newCost = newCost.toFixed(2)
                  // }
                  newCost = parseInt(newCost);
                  // costNode.innerHTML = '$' + newCost;
                  costNode.html('$' + newCost);
                }
              }
            })

            var ctaBtn = node.find('.cta_btn');
            ctaBtn.attr('href', ctaBtn.attr('href') + '?buy=1&discount_code=' + params.promo)
          })
        }
      })
      .catch(console.error)

    // apply pricing promo to navbar `/pricing` link
    $('#navbarNav .nav-item a').each(function (i, navitem) {
      var href = navitem.getAttribute('href')
      if (href && href.startsWith('/pricing')) {
        navitem.setAttribute('href', href + '?promo=' + params.promo)
      }
    });

    $('.pricing-bottom-actions-wrap a').each(function (i, navitem) {
      var href = navitem.getAttribute('href')
      if (href && href.startsWith('/pricing')) {
        var pcs = href.split('#')
        var hashtag = pcs.pop() || ''
        if (hashtag) {
          hashtag = '#' + hashtag
        }
        href = pcs.pop()
        navitem.setAttribute('href', href + '&promo=' + params.promo + hashtag)
      }
    });
  }

})();

// hero section form
(function () {
  $('form#hero-form').on('submit', (e) => {
    e.stopPropagation()
    e.preventDefault()
    var email = e.currentTarget.querySelector('input').value
    window.location.href = '/signup/index.html?email=' + email
  })
}());